/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_MESSAGES = 'REQUESTED_MESSAGES';
export const requestedMessages = () => {
  return {
    type: REQUESTED_MESSAGES
  };
};

export const RECEIVED_MESSAGES = 'RECEIVED_MESSAGES';
export const receivedMessages = (messages) => {
  return {
    type: RECEIVED_MESSAGES,
    messages
  };
};

export const ERROR_MESSAGES = 'ERROR_MESSAGES';
export const errorMessages = (error) => {
  return {
    type: ERROR_MESSAGES,
    error
  };
};

export const REQUESTED_MMR_MESSAGES = 'REQUESTED_MMR_MESSAGES';
export const requestedMmrMessages = () => {
  return {
    type: REQUESTED_MMR_MESSAGES
  };
};

export const RECEIVED_MMR_MESSAGES = 'RECEIVED_MMR_MESSAGES';
export const receivedMmrMessages = (mmrMessages) => {
  return {
    type: RECEIVED_MMR_MESSAGES,
    mmrMessages
  };
};

export const ERROR_MMR_MESSAGES = 'ERROR_MMR_MESSAGES';
export const errorMmrMessages = (error) => {
  return {
    type: ERROR_MMR_MESSAGES,
    error
  };
};
